// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "@microsoft/applicationinsights-core-js";
/**
 * Defines the level of severity for the event.
 */
export var SeverityLevel = createEnumStyle({
    Verbose: 0 /* Verbose */,
    Information: 1 /* Information */,
    Warning: 2 /* Warning */,
    Error: 3 /* Error */,
    Critical: 4 /* Critical */
});
//# sourceMappingURL=SeverityLevel.js.map